import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import { EnvironmentStages } from '../../app/models'
import type { DatadogUser } from '../../app/models/telemetry'

export const getDataDogConfig = (stage: EnvironmentStages = EnvironmentStages.dev) => {
  // NOTE: don't run on dev mode
  if (__DEV__) {
    return
  }

  datadogRum.init({
    applicationId: '05f798cf-f7f9-46b4-9919-d644aef60d5a',
    clientToken: 'pubad36e8b411b090b5e8139bedc13ef380',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    // site: '<DATADOG_SITE>',
    service: 'pp-web-application',
    env: stage,
    //  version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    enablePrivacyForActionName: true
  })

  datadogLogs.init({
    clientToken: 'pubad36e8b411b090b5e8139bedc13ef380',
    // site: '<DATADOG_SITE>',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100
  })
}

export const onDataDogSDKInitialized = async () => {
  !__DEV__ && datadogRum.setTrackingConsent('granted')
}
export const addFeatureFlagDataDog = async (featureName: string, val: boolean) => {
  datadogRum.addFeatureFlagEvaluation(featureName, val)
}

export const datadogSetAttributes = async (...args: Parameters<typeof datadogRum.setGlobalContext>) => {
  datadogRum.setGlobalContext(...args)
}

export const setUserDataDog = async ({
  userId,
  user,
  role
}: { userId: string; user: Partial<DatadogUser>; role: string }) => {
  const userData = {
    ...(userId && { id: userId }),
    ...(user.name && { name: user.name }),
    ...(user.email && { email: user.email }),
    ...(role && { type: role }),
    ...(user.gameId && { gameId: user.gameId })
  }
  return datadogLogs.setUser({
    id: userData.id,
    ...userData
  })
}
export const removeUserDataDog = async () => {
  datadogLogs.setUser({})
}

export const DdLogs = datadogLogs.logger
